import { Component, Input, inject } from '@angular/core';
import { ModalRef } from '@eg/ui';

@Component({
  selector: 'rmb-booking-confirmation',
  templateUrl: './booking-confirmation.component.html',
  styleUrls: ['./booking-confirmation.component.scss'],
  standalone: false,
})
export class BookingConfirmationComponent {
  private modalRef = inject(ModalRef);

  @Input() type: 'cancel' | 'warning';
  readonly TRANSLOCO_PREFIX = 'confirmation';

  onCloseClick(): void {
    this.modalRef.close();
  }

  onClick(response: string): void {
    if (response === 'yes') {
      this.modalRef.close('YES');
      return;
    }

    if (response === 'no') {
      this.modalRef.close('NO');
      return;
    }

    if (response === 'submit') {
      this.modalRef.close('SUBMIT');
      return;
    }
  }
}
